import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';
import {setShowDialogue} from '../store/slice/ConfSlice';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width:{lg:'75%',xs:'90%'},
  p: 4,
};

export default function ModalView({setMode,  dialogComp, title}) {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const {showDialogue} = useSelector((state)=>state.confslice);

  const handleCloseClick = () =>{
    dispatch(setShowDialogue(false));
  }

  React.useEffect(()=>{
    setOpen(showDialogue);
  },[showDialogue])
  return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} >
          <Grid container direction="column">
            <Grid container  direction="row" justifyContent="space-between" alignItems="flex-start">
              <Grid item>
                <Typography  variant="h5"  >
                {title}
                </Typography>
              </Grid>
              <Grid item>
                <CloseIcon sx={{cursor:"pointer"}} onClick={handleCloseClick}/>
              </Grid>
            </Grid>
            <Grid>
              <Divider/>
              <Box height="20px"></Box>
              
            </Grid>
            <Grid>
              {dialogComp}
            </Grid>
          </Grid>
        </Box>
      </Modal>
  );
}